export const householdSizeParam = 'householdSize';
export const sizeParam = 'size';
export const consumptionParam = 'consumption';
export const zipCodeParam = 'zipCode';
export const cityParam = 'city';
export const streetParam = 'street';
export const houseNumberParam = 'houseNumber';
export const gridOperatorNameParam = 'gridOperator';
export const currentTariffCostParam = 'currentTariffCost';
